export default __webpack_public_path__ + "images/sn-1ce79520b54b680dcc8ef40e1ed8a80b.svg";